import service from './../utils/server'

const modName = '/common/web/select/';

/**
 * 申请类型
 */
export const applicationType = data => {
    return service({
        url: modName + 'applicationType',
        method: 'post',
        data
    })
};

/**
 * 区域
 */
export const region = data => {
    return service({
        url: modName + 'region/' + data.atId,
        method: 'post',
        data
    })
};

/**
 * 渠道1
 */
export const channel1 = data => {
    return service({
        url: modName + 'channel1/' + data.regionKeyId,
        method: 'post',
        data
    })
};

/**
 * 渠道2
 */
export const channel2 = data => {
    return service({
        url: modName + 'channel2/' + data.atId,
        method: 'post',
        data
    })
};

/**
 * DC
 */
export const dcList = data => {
    return service({
        url: modName + 'dcList',
        method: 'post',
        data
    })
};

/**
 * OP
 */
export const userOpList = data => {
  return service({
    url: modName + 'userOpList',
    method: 'post',
    data
  })
};

/**
 * 客户代码
 */
export const shipToByShiptoNo = data => {
    return service({
        url: modName + 'shipToByShiptoNo',
        method: 'post',
        data
    })
};

/**
 * 客户代码
 */
export const ioList = data => {
  return service({
    url: modName + 'ioList',
    method: 'post',
    data
  })
};

/**
 * 客户组
 */
export const customerGroupList = data => {
  return service({
    url: modName + 'customerGroupList',
    method: 'post',
    data
  })
};

/**
 * 退货申请-申请人处理方式
 */
export const rtnReqProcessTypeList = data => {
  return service({
    url: modName + 'rtnReqProcessTypeList',
    method: 'post',
    data
  })
};

/**
 * 退货申请-退货原因
 */
export const rtnReqReasonList = data => {
  return service({
    url: modName + 'rtnReqReasonList',
    method: 'post',
    data
  })
};

/**
 * 退货申请-销售退货原因
 */
export const rtnReqSalerReasonList = data => {
  return service({
    url: modName + 'rtnReqSalerReasonList',
    method: 'post',
    data
  })
};

/**
 * 退货申请-非销售退货原因
 */
export const rtnReqNotSalerReasonList = data => {
  return service({
    url: modName + 'rtnReqNotSalerReasonList',
    method: 'post',
    data
  })
};

/**
 * op转单-SAP退货原因
 */
export const sapRtnReasonList = data => {
  return service({
    url: modName + 'sapRtnReasonList',
    method: 'post',
    data
  })
};

/**
 * 销售关闭状态
 * @param data
 * @returns {AxiosPromise}
 */
export const sellCloseStatusList = data => {
  return service({
    url: modName + 'sellCloseStatusList',
    method: 'post',
    data
  })
};

/**
 * 收货方信息
 * @param data
 */
export const shipTo = data => {
    return service({
        url: modName + 'shipTo',
        method: 'post',
        data
    })
};
/**
 * 终端客户
 * @param data
 */
export const endUser = data => {
    return service({
        url: modName + 'endUser',
        method: 'post',
        data
    })
};
export const endUserAndSeller = data => {
    return service({
        url: modName + 'endUserAndSeller',
        method: 'post',
        data
    })
};
/**
 * 销售
 * @param data
 */
export const sales = data => {
    return service({
        url: modName + 'sales',
        method: 'post',
        data
    })
};
/**
 * 订单状态下拉框
 * @param data
 */
export const orderStatus = data => {
    return service({
        url: modName + 'orderStatus',
        method: 'post',
        data
    })
};

/**
 * fmc收货方信息
 * @param data
 */
export const shipToFmc = data => {
  return service({
    url: modName + 'selectShipToFmc',
    method: 'post',
    data
  })
};

/**
 * soldToList
 * @param data
 * @returns {AxiosPromise}
 */
export const getSoldToList = data => {
  return service({
    url: modName + 'soldToList',
    method: 'post',
    data
  })
};

/**
 * dcNoList
 * @param data
 * @returns {AxiosPromise}
 */
export const getDcNoList = data => {
  return service({
    url: modName + 'dcNoList',
    method: 'post',
    data
  })
};

//dashboard客户列表
export const dashboardSoldToList = data =>{
  return service({
    url: '/common/web/select/dashboardSoldToList',
    method: 'post',
    data
  })
};


//供应商类型
export const getSupplierTypeList = data =>{
  return service({
    url: modName + 'supplierTypeList',
    method: 'post',
    data
  })
};

//承运商下拉列表
export const getCarrierList = data => {
  return service({
    url: modName + 'carrierList',
    method: 'post',
    data
  })
};

//线路编码下拉列表
export const getRouteList = data => {
  return service({
    url: modName + 'routeList',
    method: 'post',
    data
  })
};

//交货迟到原因归类下拉列表(lateType=10)
export const getDeliveryLateCategoryList = data => {
  return service({
    url: modName + 'deliveryLateCategoryList',
    method: 'post',
    data
  })
};

//回单迟到原因归类下拉列表(lateType=20)
export const getReceiptLateCategoryList = data => {
  return service({
    url: modName + 'receiptLateCategoryList',
    method: 'post',
    data
  })
};

//拒收原因下拉框
export const getRejectReasonList = data => {
  return service({
    url: modName + 'rejectReasonList',
    method: 'post',
    data
  });
};
//单据状态下拉框
export const getRejectStatusList = data => {
  return service({
    url: modName + 'rejectStatusList',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/api/selects.js